import React from "react";
import PropTypes from "prop-types";
import "./ColorInputStyles.scss";
const inputRef = React.createRef();

const Input = ({
  className = "",
  size = "",
  label,
  isrequired,
  colorCode,
  value,
  ...props
}) => {
  return (
    <div className="wrapper-color">
      <span className={label ? `input-label text-muted` : "d-none"}>
        {label} {isrequired && <span /*className="text-danger"*/>*</span>}
      </span>
      <input
        className="color-code-content"
        type="text"
        value={value}
        {...props}
      />
      <input
        ref={inputRef}
        type={"color"}
        className={`
          input color
          ${size}
          `}
        value={value}
        {...props}
      />
    </div>
  );
};

Input.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
};

export default Input;
